import React from 'react'

const KycPage = () => {
  return (
    <div>KycPage</div>
  )
}

export default KycPage;